const peopleOptions = [
  { name: "partner", label: "Małżonek/Partner" },
  { name: "child", label: "Dziecko" },
  { name: "other", label: "Inna osoba" },
];

export default peopleOptions;
